import { ReactNode } from "react";
import { createFastContext } from "../../../../../contexts/createFastContext";
import { IResponseUpdateUnit } from "../../../../../util/services/site";
import { FISH_HEALTH } from "../../../../../util/varibles/constants";
import { IDisease, ILiceInfo, IUnit } from "../../../../../util/varibles/interface";

interface IState {
    loading: boolean
    unit?: IUnit
    units: IUnit[]
    siteId?: string
    diseases: IDisease[]

    data: {
        fish_health?: FISH_HEALTH | null
        mortality_count?: number
        unit_diseases?: IUnit['unit_diseases']
        lice?: ILiceInfo
        unitIds: {
            id: string
            name: string
        }[]
    }

    onSave(value: IResponseUpdateUnit[]): void
}

const {
    Provider,
    useStore: useEditUnit,
    setStore: setEditUnit,
    getStore: getEditUnit,
    callEvent: callEventEditUnit
} = createFastContext<IState, {
}>({
    loading: false,
    units: [],
    diseases: [],
    data: {
        unitIds: []
    },

    onSave: () => null
});

const EditUnitProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {
    return <Provider props={{ ...args }}>
        {children}
    </Provider>
}


export { callEventEditUnit, EditUnitProvider, getEditUnit, setEditUnit, useEditUnit };

